module.exports = __webpack_public_path__ + "static/media/small-banner.e7709496.jpg";